export default __webpack_public_path__ + "static/media/Group8896.a3e7a53b.svg";